<template lang="pug">
	.toc-container.d-none.d-md-block
		div.toc-row
			h3
				span.row-image(:style="`background: url('https://web-resources.savingforcollege.com/images/table-of-contents-icon.png') no-repeat;background-size: contain;`")
				span.text
					| {{ $t("table_of_contents") }}
		div.table-of-contents
			ul
				li(v-for="innerContent of content.table_of_contents" :href="innerContent.url" @click="trackCollegeSavingsBasicsClick(innerContent.title)" :class="{active:innerContent.slug == content.slug}" :target="innerContent.slug == 'which-is-the-best-529-plan-available' ? '_blank': '_self'")
					a(:href="innerContent.url")
						| {{innerContent.title}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.toc-container
		padding: 0
		@media (max-width: 768px)
			padding: 0 15px
		.toc-row
			h3
				font-size: body-font-size-lg

				.row-image
					height: 30px
					width: 30px
					display: inline-block
					margin-right: 15px
					position: relative
					top: 7px
		.table-of-contents
			ul
				list-style: none
				padding: 15px 0
				li
					border-bottom: 1px sfc-pale-gray solid
					font-size: body-font-size-md
					width: 100%
					color: body-font-color
					transition-all()
					&.active
						border-bottom: 1px solid sfc-blue
						a
							border-bottom: 1px solid sfc-blue
					a
						color: body-font-color
						border-bottom: 1px solid #fff
						transition-all()
						padding: 7.5px 0
						display: block
					&:hover
						border-bottom: 1px solid sfc-blue
						a
							border-bottom: 1px solid sfc-blue
							&:hover
								text-decoration: none

</style>

<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"

	export default {
		props: [`content`],

		mounted(){
			SfcTrackingService.trackAnalyticsAction("Intro to 529", 'show', 'Table of contents v1')
		},
		methods: {
			trackCollegeSavingsBasicsClick(section) {
				SfcTrackingService.trackBasicsClick("Intro to 529", 'Table of contents v1', section)
			}
		}
	}
</script>
